
const RESOLVED_API_URL = process.env.REACT_APP_API_URL || (
  typeof window !== 'undefined' && window.location.hostname.includes('vercel.app')
    ? 'https://neelniketan.sweatsocial.club'  
    : 'https://neelniketan.sweatsocial.club' 
);

export const ENV_CONFIG = {
  // Production: Using neelniketan.sweatsocial.club API
  // Development: Uses Lightsail HTTPS or Heroku UAT based on REACT_APP_API_URL
  API_URL: RESOLVED_API_URL,
  PRODUCTION_API_URL: 'https://neelniketan.sweatsocial.club',
  LIGHTSAIL_API_URL: 'https://15.206.82.133',  // For switching to Lightsail later
  DEVELOPMENT_API_URL: 'https://sankalp.sweatsocial.club',
  LOCAL_API_URL: 'http://localhost:5002',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Sweat Social Admin',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  ENV: process.env.REACT_APP_ENV || 'development',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyBJGsNIpcZkdbD9oA4GUxotXcaH4z3wMFw',
 
  IS_TEST_INSTANCE: RESOLVED_API_URL.includes('sankalp'),
};

export default ENV_CONFIG;
